module.exports = __webpack_public_path__ + "static/media/(V)_MG_5036_-_Pro-Natura_-_Moda_Feminina_-_acessorios.14d99cfb.jpg";